<header>
  <app-header></app-header>
</header>

<main [class.vertical-toolbar-active]="isLandscape">
  <!-- Desktop -->
  <mat-sidenav-container *ngIf="!(serviceTools.isMobile$ | async) else mobileContent" class="sidenav-container">
    <mat-sidenav mode="side" opened [style.width]="sidenavWidth()">
      <app-sidenav [isSidenavOpen]="SidenavStore.sidenavOpen"></app-sidenav>
    </mat-sidenav>
    <mat-sidenav-content [style.margin-left]="sidenavWidth()">
      <div class="content">
        <router-outlet></router-outlet>
      </div>
    </mat-sidenav-content>
  </mat-sidenav-container>

  <!-- Mobile content in the else -->
  <ng-template #mobileContent>
    <!-- Mobile sidenav -->
    <mat-sidenav-container class="sidenav-container">
      <mat-sidenav #mobileSidenav mode="over" [opened]="SidenavStore.sidenavOpen">
        <app-sidenav [isSidenavOpen]="SidenavStore.sidenavOpen"></app-sidenav>
      </mat-sidenav>
      
      <!-- Mobile content -->
      <mat-sidenav-content>
        <div class="content">
          <router-outlet></router-outlet>
        </div>
      </mat-sidenav-content>
    </mat-sidenav-container>
  </ng-template>
</main>
